import React, { useEffect, useState } from "react";
import { postDataWithToken } from "../../Utils/restUtils";
import { postShippingAddress } from "../../CommonUrl";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Row } from "reactstrap";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";



export const addressSchema = Yup.object({
  addressType: Yup.string()
    .oneOf(["house", "work", "apartment"], "Please select a valid address type")
    .required("Address type is required"),

  name: Yup.string().min(2, "Name must be at least 2 characters").required("Name is required"),

  code: Yup.string().required("Postcode is required"),

  country: Yup.string().required("Country is required"),

  state: Yup.string().required("State is required"),
  district: Yup.string().required("City is required"),
  street: Yup.string().required("Street is required"),
  house: Yup.string().required("House/Building is required"),

  mobile: Yup.string()
  .matches(/^\+?\d{7,14}$/, "Enter a valid mobile number")
  .required("Mobile Number is required"),

    
});

const AddressAdd = ({ setisOpenAdd, list }) => {
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver:yupResolver(addressSchema)
    });

    const boxStyle = {
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        padding: "10px",
        borderRadius: "8px",
        backgroundColor: "#ffffff",
    };

    const onSubmit = async (data) => {
        const postData = {
            full_name:data?.name,
            phone: data?.mobile,
            address:data?.house,
            street: data?.street,
            city:data?.district,
            state:data?.state,
            postal_code:data.code,
            country:data?.country,
            address_type:data?.addressType,
            set_default:data?.setAsDefault
        };
        const response = await postDataWithToken(postShippingAddress, postData);
        if (response?.status === 200) {
            if (response?.data?.status === true) {
                list();
                toast.success(response?.data?.message);
                setisOpenAdd(false);
            } else {
                toast.error(response?.data?.message);
            }
        }
    };

    return (
        <div className="container mt-4" style={{height:'400px',overflowY:'scroll'}}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row justify-content-center">
                    <div className="col-md-12">
                        <div style={boxStyle}>
                            <Row>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="status" className="form-label blue">Full Name</label><span className="requireStar">*</span>
                                    <input type="text" className="form-control" placeholder="Name" {...register("name")} />
                                    <span  className="text-danger " style={{fontSize:'12px'}}>{errors.name?.message}</span>
                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="status" className="form-label blue">Mobile Number</label><span className="requireStar">*</span>
                                    <input type="text" className="form-control" placeholder="Mobile Number" {...register("mobile")} />
                                    <span  className="text-danger " style={{fontSize:'12px'}}>{errors.mobile?.message}</span>

                                </div>
                            </Row>
                            <Row>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="status" className="form-label blue">House/Building Number</label><span className="requireStar">*</span>
                                    <input type="text" className="form-control" placeholder="House Number" {...register("house")} />
                                    <span  className="text-danger " style={{fontSize:'12px'}}>{errors.house?.message}</span>

                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="status" className="form-label blue">Street Name</label><span className="requireStar">*</span>
                                    <input type="text" className="form-control" placeholder="Street Number" {...register("street")} />
                                    <span  className="text-danger " style={{fontSize:'12px'}}>{errors.street?.message}</span>

                                </div>
                            </Row>
                            <Row>
                            <div className="mb-3 col-md-6">
                                    <label htmlFor="status" className="form-label blue">City</label><span className="requireStar">*</span>
                                    <input type="text" className="form-control" placeholder="City" {...register("district")} />
                                    <span  className="text-danger " style={{fontSize:'12px'}}>{errors.district?.message}</span>

                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="status" className="form-label blue">State</label><span className="requireStar">*</span>
                                    <input type="text" className="form-control" placeholder="State" {...register("state")} />
                                    <span  className="text-danger " style={{fontSize:'12px'}}>{errors.state?.message}</span>

                                </div>
                            </Row>
                            <Row>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="status" className="form-label blue">Country</label><span className="requireStar">*</span>
                                    <input type="text" className="form-control" placeholder="Country" {...register("country")} />
                                    <span  className="text-danger " style={{fontSize:'12px'}}>{errors.country?.message}</span>

                                </div>
                                <div className="mb-3 col-md-6">
                                    <label htmlFor="status" className="form-label blue">Postal Code</label><span className="requireStar">*</span>
                                    <input type="text" className="form-control" placeholder="Postal Code" {...register("code")} />
                                    <span  className="text-danger " style={{fontSize:'12px'}}>{errors.code?.message}</span>

                                </div>
                            </Row>
                            <Row>
                                <div className="mb-3 col-md-6">
                                    <label className="form-label blue d-block">Address Type <span className="requireStar">*</span></label>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            value="house"
                                            {...register("addressType")}
                                            className="radio_animated"
                                            id="typeHouse"
                                        />
                                        <label className="form-check-label" htmlFor="typeHouse">House</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            value="work"
                                            {...register("addressType")}
                                            className="radio_animated"
                                            id="typeWork"
                                        />
                                        <label className="form-check-label" htmlFor="typeWork">Work</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            value="apartment"
                                            {...register("addressType")}
                                            className="radio_animated"
                                            id="typeApartment"
                                        />
                                        <label className="form-check-label" htmlFor="typeApartment">Apartment</label>
                                    </div>
                                    <p  className="text-danger " style={{fontSize:'12px'}}>{errors.addressType?.message}</p>

                                </div>

                                <div className="mb-3 col-md-6 d-flex align-items-end">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="checkbox_animated"
                                            id="setDefault"
                                            {...register("setAsDefault")}
                                        />
                                        <label className="form-check-label" htmlFor="setDefault">Set as Default</label>
                                    </div>
                                </div>
                            </Row>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col text-center">
                        <button type="submit" className="pay-all">Submit</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddressAdd;
